var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { TableFieldType, FilterApplyMode } from './types';
import ChoiceFilter from './filter/choice.vue';
import DateTimeFilter from './filter/datetime.vue';
import FilterCollectionMixin from './mixin/filter-collection';
var TableNonFieldFilters = /** @class */ (function (_super) {
    __extends(TableNonFieldFilters, _super);
    function TableNonFieldFilters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showFilters = false;
        _this.filterFieldCache = {};
        _this.isLoading = false;
        return _this;
    }
    TableNonFieldFilters.prototype.getFieldForFilter = function (filter) {
        if (this.filterFieldCache[filter.field_name] == null) {
            this.filterFieldCache[filter.field_name] = {
                name: filter.field_name,
                is_sortable: false,
                is_searchable: false,
                label: filter.label,
                width: null,
                type: TableFieldType.Custom,
            };
        }
        return this.filterFieldCache[filter.field_name];
    };
    TableNonFieldFilters.prototype.getFilterOptions = function (filter) {
        return __assign(__assign({}, filter), { mode: FilterApplyMode.OnChange });
    };
    Object.defineProperty(TableNonFieldFilters.prototype, "isAnyFilterActive", {
        get: function () {
            return Object.keys(this.activeFilters).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    TableNonFieldFilters.prototype.onFilter = function (field, query, callback) {
        var _this = this;
        this.$emit('filter', field, query, function () {
            callback();
            _this.showFilters = false;
        });
    };
    Object.defineProperty(TableNonFieldFilters.prototype, "filtersTooltip", {
        get: function () {
            return gettext('Filter by this column');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableNonFieldFilters.prototype, "placeholder", {
        get: function () {
            return this.fields.filter(function (o) { return o.is_searchable; }).map(function (o) { return o.label; }).join(', ');
        },
        enumerable: false,
        configurable: true
    });
    TableNonFieldFilters.prototype.data = function () {
        var searchText = this.$route.query["".concat(this.prefix, "search")];
        return {
            searchText: searchText != null ? searchText : ''
        };
    };
    TableNonFieldFilters.prototype.mounted = function () {
    };
    TableNonFieldFilters.prototype.queueSearch = function () {
        var _this = this;
        this.isLoading = true;
        window.clearTimeout(this.searchCooldownTimeout);
        this.searchCooldownTimeout = window.setTimeout(function () {
            _this.search();
        }, 500);
    };
    TableNonFieldFilters.prototype.search = function () {
        var _this = this;
        this.$emit('search', this.$refs.searchField.value, function () {
            _this.isLoading = false;
        });
    };
    __decorate([
        Prop({ type: Array })
    ], TableNonFieldFilters.prototype, "fields", void 0);
    __decorate([
        Prop({ type: Array })
    ], TableNonFieldFilters.prototype, "filters", void 0);
    __decorate([
        Prop({ type: String })
    ], TableNonFieldFilters.prototype, "prefix", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], TableNonFieldFilters.prototype, "isTableLoading", void 0);
    __decorate([
        Watch('searchText')
    ], TableNonFieldFilters.prototype, "queueSearch", null);
    TableNonFieldFilters = __decorate([
        Component({
            components: { ChoiceFilter: ChoiceFilter, DateTimeFilter: DateTimeFilter }
        })
    ], TableNonFieldFilters);
    return TableNonFieldFilters;
}(Mixins(FilterCollectionMixin)));
export default TableNonFieldFilters;
